import { render, staticRenderFns } from "./ChatMessageItem.vue?vue&type=template&id=ceada6d8&scoped=true&"
import script from "./ChatMessageItem.vue?vue&type=script&lang=js&"
export * from "./ChatMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageItem.vue?vue&type=style&index=0&id=ceada6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceada6d8",
  null
  
)

export default component.exports